<template>
  <div class="receptionOverflow">
    <div class="flex">
      <div class="commonTitle">
        <h1>会员查询</h1>
      </div>
      <div class="blockFour">
        <el-input v-model.trim="memberCardNo" style="width: 280px;" placeholder="请输入会员卡号/手机号码" @keyup.enter.native="memberSearch">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="memberSearch"></i>
        </el-input>
      </div>
      <div v-if="checkStatus == true" class="commonInfo">
        <div class="content">
          <h4>会员卡号：{{ memberInfo.cardNo }}</h4>
          <h4>姓名：{{ memberInfo.nickName }}</h4>
          <h4>手机号码：{{ memberInfo.phone }}</h4>
          <h4>微信昵称：{{ memberInfo.nickName }}</h4>
          <h4>会员等级：{{ memberInfo.gradeName }}</h4>
          <h4>余额：{{ memberInfo.money }}</h4>
          <h4>粉币：{{ memberInfo.fansCurrency }}</h4>
          <h4>积分：{{ memberInfo.integral }}</h4>
          <h4>消费总额：{{ memberInfo.expenseTotal }}</h4>
          <h4>消费次数：{{ memberInfo.expenseCount }}</h4>
        </div>
      </div>

      <div class="commonTitle">
        <h1>选择套餐</h1>
      </div>
      <div class="commonTable">
        <el-table v-if="checkStatus == true" tooltip-effect="light" :data="tableData">
          <el-table-column label="套餐名称">
            <template slot-scope="scope">
              <el-select v-model="tableData.packageName" placeholder="请选择">
                <el-option v-for="(item,index) in packageList" :key="index" :label="item.packageName" :value="item.packageId">
                  <div @click="packageChange(index)">
                    <span v-show="scope">{{ item.packageName }}</span>
                  </div>
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="价格（元）">
            <template slot-scope="scope">
              <span v-if="scope.row.money">{{ scope.row.money }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column prop="explain" label="套餐说明">
          </el-table-column>
          <el-table-column label="折扣">
            <template slot-scope="scope">
              <span v-show="scope">{{ memberInfo.discount == 10 || !memberInfo.discount ? '--' : memberInfo.discount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="实收（元）">
            <template slot-scope="scope">
              <span>{{ (scope.row.money * memberInfo.discount / 10).toFixed(2) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <gt-noneData v-else></gt-noneData>
      </div>

      <div v-if="checkStatus == true">
        <div class="commonTitle">
          <h1>选择抵扣优惠</h1>
        </div>
        <div class="commonCard">
          <ul v-if="memberInfo.cardList">
            <div v-for="(item,index) in memberInfo.cardList" :key="index" class="liOverflow">
              <li :class="chooseLiIndex == index ? 'select' : ''" @click="chooseCoupon(index,item.cardType,item.cashLeastCost,item.addUser)">
                <span></span>
                <label></label>
                <h3 v-if="item.cardType == 0">{{ item.discount }}折</h3>
                <h3 v-else>满{{ item.cashLeastCost }}减{{ item.reduceCost }}</h3>
                <h4 v-if="item.cardType == 0">
                  折扣卡
                  <small>x{{ item.count }}</small>
                </h4>
                <h4 v-else>
                  减免券
                  <small>x{{ item.count }}</small>
                </h4>
                <h5 v-if="chooseLiIndex == index">已选择 x {{ chooseCardNum }}</h5>
              </li>
            </div>
          </ul>
          <div class="integral">
            <div :class="chooseIntegral == true ? 'li active' : 'li'" @click="changeIntegral">
              <h1>{{ memberInfo.integral }}积分</h1>
              <h2>（{{ memberInfo.jifenMoeny }}元）</h2>
              <p v-if="chooseIntegral == true">已抵扣{{ integralYhj }}元</p>
            </div>
            <div :class="chooseFansBi == true ? 'li active' : 'li'" @click="changeFansBi">
              <h1>{{ memberInfo.fansCurrency }}粉币</h1>
              <h2>（{{ memberInfo.fenbiMoeny }}元）</h2>
              <p v-if="chooseFansBi == true">已抵扣{{ fansBiYhj }}元</p>
            </div>
          </div>
        </div>

        <div class="commonTitle">
          <h1>结算信息</h1>
        </div>
        <div class="commonJsInfo">
          <p>
            消费金额：
            <span>￥{{ moneyInfo.consumeMoney }}</span>
          </p>
          <p>
            优惠金额：
            <span>-￥{{ moneyInfo.reduceMoney }}</span>
          </p>
          <p>
            应收金额：
            <label>￥{{ moneyInfo.realMoney }}</label>
          </p>
        </div>

        <div class="commonTitle">
          <h1>付款方式</h1>
        </div>
        <div class="payStyleBox">
          <div class="pay-box-header">
            <strong>选择支付方式 </strong>
          </div>
          <div class="pay-box-body clearFix" style="height: 147px;">
            <div class="pay-mode-box">
              <a :class="choosePayStatus == 1 ? 'checked' : ''" @click="choosePay('1')">
                <i class="iconfont" :class="choosePayStatus == 1 ? '' : 'themeFC'">&#xe62b;</i>
                <span>现金支付</span>
              </a>
            </div>
            <div class="pay-mode-box">
              <a :class="choosePayStatus == 2 ? 'checked' : ''" @click="choosePay('2')">
                <i class="iconfont" :class="choosePayStatus == 2 ? '' : 'themeFC'">&#xe705;</i>
                <span>银行卡支付</span>
              </a>
            </div>
            <div v-if="memberInfo.ctName == '储值卡'" class="pay-mode-box">
              <a :class="choosePayStatus == 3 ? 'checked' : ''" @click="choosePay('3')">
                <i class="iconfont" :class="choosePayStatus == 3 ? '' : 'themeFC'">&#xe61a;</i>
                <span>会员卡支付</span>
              </a>
            </div>
            <div class="pay-mode-box">
              <a :class="choosePayStatus == 4 ? 'checked' : ''" @click="choosePay('4')">
                <i class="iconfont" :class="choosePayStatus == 4 ? '' : 'themeFC'">&#xe630;</i>
                <span>扫码支付</span>
              </a>
            </div>
            <p v-if="choosePayStatus == 1">
              收取金额：
              <el-input v-model.trim="totalMoney" style="width: 120px;" type="number" placeholder="请输入收取金额" @keyup.enter.native="Lib.keyboardBlur"></el-input>
              <span>找零：
                <small>￥</small>
                <b>{{ giveMoney }}</b>
              </span>
            </p>
            <!-- <p v-else-if="choosePayStatus == 2">银行流水号：
              <el-input @keyup.enter.native="Lib.keyboardBlur" style="width: 120px;" v-model.trim="payOrderCode" placeholder="请输入银行流水号"></el-input>
            </p> -->
          </div>
        </div>

        <div class="blockFive">
          <el-button type="primary" :disabled="disPayBtn" @click="confirmPay('0')">确认买单</el-button>
          <el-button type="primary" :disabled="disPayBtn" @click="confirmPay('1')">确认并打印</el-button>
          <el-button :disabled="disPayBtn" @click="cancelPay">取消</el-button>
        </div>
      </div>

      <el-dialog title="扫码支付" width="500px" :visible.sync="eqCodePayDialog" :append-to-body="true">
        <div class="commonNewPay">
          <p v-if="changePayImgStatus">
            <img src="static/images/weixin.png" />
            <label>微信支付</label>
          </p>
          <p v-else>
            <img src="static/images/zhifubao.png" />
            <label>支付宝支付</label>
          </p>
          <p>
            需支付金额：
            <span v-text="'¥'+moneyInfo.realMoney"></span>
          </p>
          <p class="nmb_20">方式：顾客扫码支付</p>
          <img class="eqCodeImg" :src="eqCodeImage" :alt="eqCodeImage">
          <p class="nmt_20">{{ changePayImgStatus ? '请打开微信扫一扫进行支付' : '请打开支付宝扫一扫进行支付' }}</p>
          <p class="new_click" @click="changePayImgStatus = !changePayImgStatus">{{ changePayImgStatus ? '使用支付宝支付' : '使用微信支付' }}</p>
        </div>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="500px" :before-close="cancelPay" :append-to-body="true">
        <span>是否打印订单？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelPay">取 消</el-button>
          <el-button type="primary" @click="comfirmPrint">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getMemberCardMsg, postPayOrder, getSaleCardList, getScanPayQRCode, getScanPayStatus, printOrder, hasPrintSet
} from './api';
// var integralYhj = 0;
// var fansBiYhj = 0;
let payTimeOut;
export default {
  data() {
    return {
      memberCardNo: '', // 会员卡号
      memberInfo: {}, // 会员信息
      checkStatus: false, // 检查查询状态
      tableData: [
        {
          packageName: '',
          money: '',
          explain: ''
        }
      ],
      tableDataNone: [], // 空数据
      packageList: [], // 套餐列表
      chooseIntegral: false, // 选择积分
      integralYhj: 0, // 抵扣优惠价
      chooseFansBi: false, // 选择粉币
      fansBiYhj: 0, // 抵扣粉币价格
      chooseLiIndex: '-1', // 选择优惠券
      chooseCardType: '', // 优惠券的类型
      chooseAddStatus: '', // 优惠券可叠加与否  false--不可叠加，true--可叠加
      chooseCardNum: '', // 选择优惠券的数量
      getOrderId: '', // 扫码支付
      eqCodePayDialog: false, // 扫码支付弹出窗口
      eqCodeImage: '', // 扫码支付二维码
      moneyInfo: {
        consumeMoney: '0.00',
        reduceMoney: '0.00',
        realMoney: '0.00'
      },
      choosePayStatus: '1', // 选择支付方式
      disPayBtn: false, // 支付按钮状态
      totalMoney: '0', // 现金支付金额
      giveMoney: '0.00', // 找零金额
      payOrderCode: '', // 支付订单号
      dialogVisible: false, // 打印弹出窗口
      newOrderNo: '', // 购买生成的订单号
      changePayImgStatus: true, // 扫码支付切换支付方式，true为微信支付，fasle为支付宝支付
    };
  },
  // 监听二维码弹出框和总价的变化
  watch: {
    totalMoney() {
      this.changeCashPay();
    },
    eqCodePayDialog(val) {
      if (val == false) {
        this.choosePayStatus = 1;
        clearTimeout(payTimeOut);
      }
    },
    changePayImgStatus(val) {
      const vm = this;
      const data = {
        money: this.moneyInfo.realMoney,
        payWay: val ? 1 : 2
      };
      getScanPayQRCode(data).then((res) => {
        if (res.code === 0) {
          clearTimeout(payTimeOut);
          this.getOrderId = res.data.orderCode;
          this.eqCodeImage = `${res.data.url}&${new Date().getTime()}`;
          setTimeout(() => {
            vm.getPayStatus();
          }, 3000);
        }
      });
    }
  },
  created() {
    this.getPackageList();
  },
  methods: {
    // 会员查询
    memberSearch() {
      this.Lib.keyboardBlur();
      const data = {
        keyWord: this.memberCardNo
      };
      getMemberCardMsg(data).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.checkStatus = true;
            this.memberInfo = res.data;
          } else {
            this.checkStatus = false;
            this.memberInfo = {};
            this.$message('该会员卡号不存在，请重新输入');
          }
        }
      });
    },
    // 套餐选择
    packageChange(index) {
      this.chooseIntegral = false;
      this.chooseFansBi = false;
      this.chooseLiIndex = '-1';
      this.integralYhj = 0;
      this.fansBiYhj = 0;
      this.tableData[0] = this.packageList[index];
      this.moneyInfo.consumeMoney = this.packageList[index].money;
      this.countFavorablePrice();
    },
    // 选择积分
    changeIntegral() {
      if (!this.tableData[0].packageName) {
        this.$message('请选择套餐');
        return;
      }
      if (this.memberInfo.jifenMoeny == 0) {
        this.$message('没有可用积分');
        return;
      }
      if (this.chooseIntegral == false) {
        if (this.memberInfo.jifenStartMoney > this.moneyInfo.realMoney) {
          this.$message(`积分不可用,应付金额要大于${this.memberInfo.jifenStartMoney}`);
          return;
        }
      }
      this.chooseIntegral = !this.chooseIntegral;
      if (this.chooseIntegral == true) {
        if (
          parseFloat(this.memberInfo.jifenMoeny)
          > parseFloat(this.moneyInfo.realMoney)
        ) {
          this.integralYhj = this.moneyInfo.realMoney;
        } else {
          this.integralYhj = this.memberInfo.jifenMoeny;
        }
        this.moneyInfo.realMoney = (this.moneyInfo.realMoney * 1 - this.integralYhj * 1);
      } else {
        this.integralYhj = 0;
      }
      this.countFavorablePrice();
    },
    // 选择粉币
    changeFansBi() {
      if (!this.tableData[0].packageName) {
        this.$message('请选择套餐');
        return;
      }
      if (this.memberInfo.fenbiMoeny == 0) {
        this.$message('没有可用粉币');
        return;
      }
      if (this.chooseFansBi == false) {
        if (this.memberInfo.fenbiStartMoney > this.moneyInfo.realMoney) {
          this.$message(`粉币不可用,应付金额要大于${this.memberInfo.fenbiStartMoney}`);
          return;
        }
      }
      this.chooseFansBi = !this.chooseFansBi;
      if (this.chooseFansBi == true) {
        if (
          parseFloat(this.memberInfo.fenbiMoeny)
          > parseFloat(this.moneyInfo.realMoney)
        ) {
          const fensBiNum = Math.floor(
            this.moneyInfo.realMoney / this.memberInfo.fenbiStartMoney
          );
          this.fansBiYhj = this.memberInfo.fenbiStartMoney * fensBiNum;
        } else {
          this.fansBiYhj = this.memberInfo.fenbiMoeny;
        }
        this.moneyInfo.realMoney = (this.moneyInfo.realMoney * 1 - this.fansBiYhj * 1);
      } else {
        this.fansBiYhj = 0;
      }
      this.countFavorablePrice();
    },
    // 计算优惠的价格
    countFavorablePrice() {
      let memberYhj;
      if (this.chooseLiIndex == '-1') {
        this.chooseCardNum = '';
        memberYhj = this.moneyInfo.consumeMoney
          - this.moneyInfo.consumeMoney * this.memberInfo.discount * 0.1;
        this.moneyInfo.realMoney = this.moneyInfo.consumeMoney - memberYhj;
      } else if (this.chooseCardType == 0) {
        this.chooseCardNum = 1;
        memberYhj = this.moneyInfo.consumeMoney - this.moneyInfo.consumeMoney * this.memberInfo.cardList[this.chooseLiIndex].discount * 0.1;
      } else if (this.chooseAddStatus == 0) {
        this.chooseCardNum = 1;
        memberYhj = this.memberInfo.cardList[this.chooseLiIndex].reduceCost
              * this.chooseCardNum;
      } else {
        const cardNum = Math.floor(this.moneyInfo.consumeMoney / this.memberInfo.cardList[this.chooseLiIndex].cashLeastCost);
        if (cardNum > this.memberInfo.cardList[this.chooseLiIndex].count) {
          this.chooseCardNum = this.memberInfo.cardList[this.chooseLiIndex].count;
        } else {
          this.chooseCardNum = cardNum;
        }
        memberYhj = this.memberInfo.cardList[this.chooseLiIndex].reduceCost * this.chooseCardNum;
      }
      this.moneyInfo.reduceMoney = (memberYhj * 1
        + this.integralYhj * 1
        + this.fansBiYhj * 1
      ).toFixed(2);
      this.moneyInfo.realMoney = (this.moneyInfo.consumeMoney
        - this.moneyInfo.reduceMoney
      ).toFixed(2);
      this.totalMoney = (this.moneyInfo.consumeMoney
        - this.moneyInfo.reduceMoney
      ).toFixed(2);
    },
    // 选择优惠券
    chooseCoupon(val, type, money, addStatus) {
      if (!this.tableData[0].packageName) {
        this.$message('请选择套餐');
        return;
      }
      if (parseFloat(money) > parseFloat(this.moneyInfo.consumeMoney)) {
        this.$message('优惠不可用');
        return;
      }
      this.integralYhj = 0;
      this.fansBiYhj = 0;
      this.chooseIntegral = false;
      this.chooseFansBi = false;
      if (this.chooseLiIndex == val) {
        this.chooseLiIndex = '-1';
      } else {
        this.chooseLiIndex = val;
      }
      this.chooseCardType = type;
      this.chooseAddStatus = addStatus;
      this.countFavorablePrice();
    },
    // 选择支付方式
    choosePay(val) {
      const vm = this;
      this.choosePayStatus = val;
      if (val == 4) {
        this.eqCodePayDialog = true;
        const data = {
          money: this.moneyInfo.realMoney,
          payWay: this.changePayImgStatus ? 1 : 2
        };
        getScanPayQRCode(data).then((res) => {
          this.getOrderId = res.data.orderCode;
          this.eqCodeImage = `${res.data.url}&${new Date().getTime()}`;
          setTimeout(() => {
            vm.getPayStatus();
          }, 3000);
        });
      }
    },
    // 获取扫码支付支付状态
    getPayStatus() {
      const vm = this;
      const data = {
        orderCode: this.getOrderId
      };
      getScanPayStatus(data).then((res) => {
        if (res.code == 0) {
          if (res.data.status == 0) {
            payTimeOut = setTimeout(() => {
              vm.getPayStatus();
            }, 3000);
          } else if (res.data.status == 1) {
            this.eqCodePayDialog = false;
            this.$message({ message: '扫码支付成功', type: 'success' });
            vm.confirmPay('0', '99');
          } else if (res.data.status == -1) {
            this.eqCodePayDialog = false;
            this.$message('二维码已失效，请重新获取');
          }
        }
      });
    },
    // 改变收取的现金
    changeCashPay() {
      this.giveMoney = (this.totalMoney - this.moneyInfo.realMoney).toFixed(2);
    },
    // 确认买单--判断是否配置打印机
    confirmPay(val, status) {
      if (val == 1) {
        hasPrintSet({}).then((res) => {
          if (res.code == 0) {
            this.realConfirmPay(val, status);
          }
        });
      } else {
        this.realConfirmPay(val, status);
      }
    },
    // 确定买单
    realConfirmPay(val, status) {
      if (!this.tableData[0].packageName) {
        this.$message('请选择套餐');
        return;
      }
      if (this.choosePayStatus == 1) {
        if (parseFloat(this.moneyInfo.realMoney) > parseFloat(this.totalMoney)) {
          this.$message('收取金额必须大于等于应收金额');
          return;
          // this.totalMoney = (this.moneyInfo.consumeMoney -
          //     this.moneyInfo.reduceMoney
          // ).toFixed(2);
        }
      }
      const files = this.tableData;
      const arr = [];
      for (let i = 0, len = files.length; i < len; i++) {
        const item = files[i];
        const obj = {};
        obj.cardid = item.packageId;
        obj.discount = this.memberInfo.discount;
        obj.name = item.packageName;
        obj.price = item.money;
        obj.validdate = item.validDate;
        arr.push(obj);
      }
      let newCardId;
      let newCardNo;
      if (this.chooseLiIndex == -1) {
        newCardId = '';
        newCardNo = '';
      } else {
        newCardId = this.memberInfo.cardList[this.chooseLiIndex].gid;
        newCardNo = this.memberInfo.cardList[this.chooseLiIndex].code;
      }
      const data = {
        bankCode: this.choosePayStatus == 2 ? this.payOrderCode : '',
        cardId: newCardId,
        cardNo: newCardNo,
        cardNum: this.chooseCardNum,
        cutFee: this.moneyInfo.reduceMoney,
        fansCurrency: this.fansBiYhj * this.memberInfo.fenbiRatio,
        integral: this.integralYhj * this.memberInfo.jifenStartMoney,
        memberCode: this.memberInfo.cardNo,
        memberId: this.memberInfo.memberId,
        memberName: this.memberInfo.nickName,
        orderCode: this.choosePayStatus == 4 ? this.getOrderId : '',
        orderId: '',
        packageList: JSON.stringify(arr),
        payType: this.choosePayStatus,
        payamount: this.choosePayStatus == 1 ? this.totalMoney : '0',
        phone: this.memberInfo.phone,
        returnamount: this.choosePayStatus == 1 ? this.giveMoney : '0',
        toPay: this.moneyInfo.realMoney
      };
      this.disPayBtn = true;
      postPayOrder(data).then((res) => {
        if (res.code == 0) {
          this.$message({ message: '购买成功', type: 'success' });
          this.newOrderNo = res.data.orderNo;
          if (val == 1) {
            this.dataPrint();
          } else if (status == 99) {
            this.dialogVisible = true;
          } else {
            Object.assign(this.$data, this.$options.data());
            this.getPackageList();
          }
        } else {
          this.$message(res.msg);
        }
        this.disPayBtn = false;
      });
    },
    // 取消
    cancelPay() {
      Object.assign(this.$data, this.$options.data());
      this.getPackageList();
      this.$store.commit('deleteTabs', 'stage-packageBuy');
      this.$router.push({
        name: 'stage-index'
      });
    },
    // 打印
    dataPrint() {
      const data = {
        orderId: this.newOrderNo,
        mainId: this.$store.state.mainId,
        printType: 2, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
        isManual: 1
      };
      printOrder(data).then((res) => {
        if (res.code == 0) {
          this.dialogVisible = false;
          this.cancelPay();
          Object.assign(this.$data, this.$options.data());
          this.getPackageList();
        }
      });
    },
    // 确定打印
    comfirmPrint() {
      this.dataPrint();
    },
    // 可购买的套餐列表
    getPackageList() {
      const data = {};
      getSaleCardList(data).then((res) => {
        this.packageList = res.data;
      });
    }
  }
};
</script>
